<template>
  <section class="new-year">
    <h3 style="margin-bottom: -3px">NEW YEAR FESTIVAL</h3>

    <MiniCarrousel :photos="nyeImages"
                   class="btn"
                   color="#605874"
                   link="/tulum-new-year-festival-2025"
    ></MiniCarrousel>
    <br>

    <router-link
      class="card-link btn-link"
      :to="{path: '/nye'}">

      High Season Event Line
    </router-link>
    <p style="color: indianred !important;">NYE 2025-2026</p>

  </section>
</template>
<script>
import MiniCarrousel from '@/components/MiniCarrousel';

export default {
  name: 'NewYearCarrousel',
  data: () => {
    return {

      nyeImages: ['https://imgix.cosmicjs.com/f880e490-67df-11f0-8dad-d75ad6bcbc72-keinemusik2026.jpeg',
        'https://imgix.cosmicjs.com/dbad3f70-6b2d-11f0-a543-736362bb2d0f-photo_2025-07-27-15-08-20.jpeg',
        'https://imgix.cosmicjs.com/1b7943f0-6b16-11f0-a543-736362bb2d0f-IMG_4297.jpg'],    }
  },
  components: { MiniCarrousel },


};
</script>
<style scoped>
.new-year {

  margin: 30px;
  border-bottom: 6px solid #76cdc5;
  /*background: linear-gradient(to top, rgba(26, 26, 28, 0.9) 10%, rgb(53, 28, 26) 100%);*/
}
</style>
